export default {"src":"/_next/static/media/laisse-obligatoire.8b893b30.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};